export const getFlipperCount = (state) => state.flipper.count;

export const getFlipperSrcFirst = (state) => state.flipper.srcFirst;
export const getFlipperSrcSecond = (state) => state.flipper.srcSecond;
